<template>
  <div id="app">
	<!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
      <router-link to="/reading">reading</router-link>
    </div>
	-->
    <router-view v-if="initialized"/>

    <!--
    <vue-drawing-canvas ref="VueCanvasDrawing" 
    :line-join="'round'"/>
    <button @click="Test">Test</button>
    -->

	<!--Preload assets-->
	<div style="display: none;">
		<img :src="require('./assets/momo_1.png')">
		<img :src="require('./assets/momo_2.png')">
		<img :src="require('./assets/momo_correct.png')">
		<img :src="require('./assets/momo_wrong.png')">
	</div>

  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import VueDrawingCanvas from "vue-drawing-canvas";

export default {
  name: 'App',
  components: {
    HelloWorld, VueDrawingCanvas
  },
  data() {
    return {
      worker: null,
	  initialized: false,
    }
  },
	async mounted() {
		this.Initialize();
		this.Resize();

		window.addEventListener('resize', () => {
			this.Resize();
		})

    /*
    const { createWorker } = require('tesseract.js');

    this.worker = await createWorker({
      logger: m => console.log(m),
    });

    await this.worker.loadLanguage('jpn');
    await this.worker.initialize('jpn');
    */
    //const { data: { text } } = await worker.recognize('https://tesseract.projectnaptha.com/img/eng_bw.png');
    //console.log(text);
    //await this.worker.terminate();
  },
	methods: {
		Initialize() {
			var dictionary = require('./assets/dictionary.json');
			this.$store.commit('Initialize', dictionary);
			this.initialized = true;
		},
		Resize() {
			if (!window.visualViewport) {
				return
			}

			let height = window.visualViewport.height;
			document.body.style.height = parseInt(height) + 'px';

		},
		async Test() {
			var canvas = document.getElementById('VueDrawingCanvas');
			var img = canvas.toDataURL("image/png");
			console.log(img);
			const { data: { text } } = await this.worker.recognize(img);
			console.log(text);
		}
  	}
}
</script>
<style lang="scss">

:root {
	--blue: #0093dd;
	--light-blue: #72bde8;
	--brown: #7d2d3c;
	--dark-blue: #0078b5;
	--green: #78e647;
	--red: #ea5545;
}

* {
	box-sizing: border-box;
}

html, body {
	padding: 0px;
	margin: 0px;
	background-color: var(--blue);
}

body {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  
}

</style>
